import React, { useContext, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import PartnerNavComponent from './PartnerNavComponent'
import PartnerContext from '../../hooks/PartnerContext';
import axiosInstance from '../../services/api/axiosInstance';

const PartnerAuth = () => {
  const partnerPageDashboardMenu = ["Home", "Pool"];

  const pageRender = useNavigate();

  const { setSubscriptionExpired } = useContext(PartnerContext);

  useEffect(() => {

    const get_payment_status = async () => {
      try {
        const res = await axiosInstance.get('/get_payment_status_partner')

        if (res.data.error_code === 300) {
          if (window.location.pathname !== '/partner_dashboard/home') {
            pageRender('/partner_dashboard/home', { replace: true })
          }

          setSubscriptionExpired(true)
        } else {
          if (res.data.error_code === 0) {
            setSubscriptionExpired(false)
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
    get_payment_status();

  }, [])

  return (
    <>
      <PartnerNavComponent dashboadMenus={partnerPageDashboardMenu} />
      <Outlet />
    </>
  )
}

export default PartnerAuth